/*
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { Component, ComponentRef, ViewChild } from '@angular/core';

import { ElComponentPortal } from '../cdk/overlay/mapping';
import { ElOverlayContainerComponent, ElPositionedContainer } from '../cdk/overlay/overlay-container';


@Component({
  selector: 'el-datepicker-container',
  styleUrls: ['./datepicker-container.component.css'],
  template: `
    <span class="arrow"></span>
    <el-overlay-container></el-overlay-container>
  `,
})
export class ElDatepickerContainerComponent extends ElPositionedContainer {

  // TODO static must be false as of Angular 9.0.0, issues/1514
  @ViewChild(ElOverlayContainerComponent, { static: true }) overlayContainer: ElOverlayContainerComponent;

  attach<T>(portal: ElComponentPortal<T>): ComponentRef<T> {
    return this.overlayContainer.attachComponentPortal(portal);
  }
}
